import { createBrowserRouter, RouteObject } from 'react-router';
import ApplicationRouterErrorBoundary from '@/Infrastructure/Components/ErrorHandling/ApplicationRouterErrorBoundary';
import { ApplicationErrorType } from '@/Infrastructure/Components/ErrorHandling/types';
import Index from '@/Infrastructure/Components/Layout/Index';
import Logout from '@/Infrastructure/Security/Logout';
import Research from '@/Research/Research';
import TerminalManagement from '@/Terminals/TerminalManagement';
import Terminals from '@/Terminals/Terminals';
import TerminalProxy from './TerminalProxy';
import BoardQueryProxy from './BoardQueryProxy';
import Page from '@dispatchBoard/Page';
import EdiLoadTenderPage from '@/EdiLoadTender/Page';
import AgentSettlementsPage from '@/AgentSettlements/Page';
import BoardQueriesPage from '@/BoardQueries/Page';
import { setRouterInstance } from './routerInstance';

/**
 * Using React.lazy for code-splitting purposes to reduce our chunk sizes
 */
// const LazyDispatchBoard = lazy(() => import('../../Board/Page'));

export const routes: RouteObject[] = [
  {
    path: '',
    element: <Index />,
    errorElement: <ApplicationRouterErrorBoundary applicationErrorType={ApplicationErrorType.Unexpected} />,
    children: [
      {
        path: '',
        element: <Terminals />
      },
      {
        path: ':terminalNumber',
        element: <TerminalProxy />,
        errorElement: <ApplicationRouterErrorBoundary applicationErrorType={ApplicationErrorType.Unexpected} />,
        children: [
          {
            path: '',
            element: <TerminalManagement />
          },
          {
            path: 'Board',
            element: <BoardQueryProxy />,
            children: [
              {
                path: '',
                element: <Page />
              },
              {
                path: ':query',
                element: <Page />
              }
            ]
          },
          {
            path: 'Research',
            element: <Research />
          },
          {
            path: 'EDI',
            element: <EdiLoadTenderPage />
          },
          {
            path: 'settlements',
            element: <AgentSettlementsPage />
          },
          {
            path: 'queries',
            element: <BoardQueriesPage />
          }
        ]
      },
      {
        path: '*',
        element: <ApplicationRouterErrorBoundary applicationErrorType={ApplicationErrorType.NotFound} />
      }
    ]
  },
  {
    path: 'logout',
    element: <Logout />
  }
];

export const router = createBrowserRouter(routes);
setRouterInstance(router);
